import {Injectable} from '@angular/core';
import {App, LoadingController, NavController} from 'ionic-angular';
import {Observable} from 'rxjs/Observable';
// import { Observer } from 'rxjs/Observer';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';
import {Http} from '@angular/http';

// import { NewRegistrationExistsPage } from '../../pages/new-registration-exists/new-registration-exists';
import {Storage} from '@ionic/storage';
import {AlertProvider} from '../../providers/alert/alert';
import {AuthProvider} from '../../providers/auth/auth';
import {NetworkMonitorProvider} from '../../providers/network-monitor/network-monitor';

import {NewSubscription} from '../../models/newsubscription';

/*
  Generated class for the NewSubscriptionProvider provider.

  See https://angular.io/docs/ts/latest/guide/dependency-injection.html
  for more info on providers and Angular DI.
*/
@Injectable()
export class NewSubscriptionProvider {

  private key: string = 'new_subscription';
  private keyContinuation: string = 'new_subscription_continuation';

  constructor(
    private storage: Storage,
    private loadingCtrl: LoadingController,
    private alertProvider: AlertProvider,
    private app: App,
    private networkMonitorProvider: NetworkMonitorProvider,
    private http: Http,
    private authProvider: AuthProvider
  ) {
    console.log('Hello NewSubscriptionProvider Provider');

    var that = this;
    that.storage.remove(that.key).then();
    that.storage.remove(that.keyContinuation).then();
  }

  /**
   * Get the NavController (to enable this provider to navigate over the pages).
   */
  private get navCtrl(): NavController {
    // (getRootNav) is deprecated and will be removed in the next major release. Use getRootNavById instead.
    // App.getRootNav
    // return this.app.getRootNav();
    return this.app.getRootNavs()[0]
  }

  /**
   * Try to fetch a saved data.
   */
  private fetch(): Observable<any> {
    let that = this;

    return Observable.create((observer: any) => {
      that.storage.get(that.key).then((value: string) => {
        if (value) {
          observer.next(JSON.parse(value));
          observer.complete();
        } else {
          observer.next(null);
          observer.complete();
        }
      }).catch((error: any) => {
        console.log(error);
        observer.next(null);
        observer.complete();
      });
    });
  }

  /**
   * Save the data.
   *
   * @param data Data to be saved.
   */
  private async save(data: any): Promise<any> {
    return await this.storage.set(this.key, JSON.stringify(data));
  }

  /**
   * Detroy entirely data of new subscription.
   */
  public destroy(): Observable<void> {
    let that = this;

    return Observable.create((observer: any) => {

      that.storage.remove(that.key).then(() => {

        that.storage.remove(that.keyContinuation).then(() => {

          observer.next();
          observer.complete();

        }).catch((error: any) => {
          console.log(error);
          observer.next();
          observer.complete();
        });

      }).catch((error: any) => {
        console.log(error);
        observer.next();
        observer.complete();
      });
    });
  }

  /**
   * Define this new subscription as continuation of another new subscription.
   */
  private async setAsContinuation(): Promise<any> {
    return await this.storage.set(this.keyContinuation, JSON.stringify(true));
  }

  /**
   * Load (the data) at verification page (@see new-subscription-step1)
   *
   * @param page Page to go after load the data.
   */
  public loadAtVerificationPage(page: any): Observable<any> {
    let loader = this.loadingCtrl.create({
      content: 'Verificando se existe uma inscrição pendente...',
      //duration: 3000
    });
    loader.present();

    let that = this;

    return Observable.create((observer: any) => {

      this.fetch().subscribe((data: any) => {
        loader.dismiss();

        if (data) {
          console.log(data);

          that.alertProvider.doConfirm('Encontramos uma inscrição não concluída. Deseja continuar esta inscrição?', () => {

            let loader = that.loadingCtrl.create({
              content: 'Preparando a continuação...',
              //duration: 3000
            });
            loader.present();

            that.setAsContinuation().then(() => {
              loader.dismiss();
              that.navCtrl.push(page, {}, {
                animation: 'ios-transition'
              });

              observer.next(data);
              observer.complete();
            }).catch((error: any) => {
              console.log(error);
              loader.dismiss();
              that.navCtrl.push(page, {}, {
                animation: 'ios-transition'
              });

              console.log(error);
              observer.next(data);
              observer.complete();
            });

          }, () => {

            let loader = that.loadingCtrl.create({
              content: 'Preparando o formulário...',
              //duration: 3000
            });
            loader.present();

            that.destroy().subscribe(() => {
              loader.dismiss();

              observer.next(data);
              observer.complete();
            }, (error: any) => {
              console.log(error);
              loader.dismiss();

              observer.next(data);
              observer.complete();
            });

          });
        }
      }, (error: any) => {
        console.log(error);
        loader.dismiss();

        observer.next(null);
        observer.complete();
      });
    });
  }

  /**
   * Load data.
   */
  public load(): Observable<any> {
    let loader = this.loadingCtrl.create({
      content: 'Obtendo suas informações...',
      //duration: 3000
    });
    loader.present();

    return Observable.create((observer: any) => {

      this.fetch().subscribe((data: any) => {
        loader.dismiss();

        console.log(data);
        observer.next(data);
        observer.complete();
      }, (error: any) => {
        console.log(error);
        loader.dismiss();

        observer.next(null);
        observer.complete();
      });

    });
  }

  doApplyCourseCode(data: any): Observable<any[]> {
    return null;
  }

  /**
   * Try to verify the data. If it exists, return a list of emails in a page.
   *
   * @param data Data to be verified.
   */

  /*
  public doVerification(data: any): Observable<any[]> {
    let that = this;

    return Observable.create((observer: any) => {

      if (!this.networkMonitorProvider.isOnline()) {

        this.alertProvider.doAlert('É necessário estar conectado na Internet para realizar a verificação dos seus dados.', 'Atenção');

        observer.next(null);
        observer.complete();

      } else {

        let loader = this.loadingCtrl.create({
          content: 'Verificando...',
          //duration: 3000
        });
        loader.present();

        // console.log(Config.baseUrl + '/users/registration/verify');
        // console.log(data);

        this.http.post(Config.baseUrl + '/users/registration/verify', data)
          .map((res: Response) => res.json())
          .subscribe((response: any) => {

            console.log(response);
            loader.dismiss();

            observer.next(response.response.emails);
            observer.complete();

          }, (error: any) => {

            console.log(error);
            loader.dismiss();
            that.alertProvider.doAlert('Houve problemas ao verificar suas informações.', 'Atenção');

            observer.next(null);
            observer.complete();

          });

      }
    });
  }
  */

  /**
   * Save the data.
   *
   * @param data Data to be saved.
   */
  private saveData(data: any): Observable<boolean> {
    let that = this;
    let loader = that.loadingCtrl.create({
      content: 'Salvando suas informações...',
      // duration: 3000
    });
    loader.present();

    return Observable.create((observer: any) => {

      this.save(data).then(() => {
        loader.dismiss();

        observer.next(true);
        observer.complete();
      }, (error: any) => {
        console.log(error);
        loader.dismiss();

        observer.next(false);
        observer.complete();
      });
    });
  }

  /**
   * Save the data and go to page specified.
   *
   * @param data Data to be saved.
   * @param page Page to go when the data be saved with success.
   */
  public saveDataAndGoToPage(data: any, page: any) {
    let that = this;
    this.saveData(data).subscribe((saved: boolean) => {

      if (saved) {
        if (page == -1) {
          that.navCtrl.pop({
            animation: 'ios-transition'
          });
        } else {
          that.navCtrl.push(page, {}, {
            animation: 'ios-transition'
          });
        }
      } else {
        that.alertProvider.doAlert('Houve problemas ao salvar suas informações.', 'Atenção');
      }

    }, (error: any) => {
      console.log(error);
      that.alertProvider.doAlert('Houve problemas ao salvar suas informações.', 'Atenção');
    });
  }

  /**
   * Do the subscription with data.
   *
   * @param data Data to be saved and send.
   */
  public doRegister(data: any) {
    let that = this;
    /*
    this.saveData(data).subscribe((saved: boolean) => {

      if (saved) {

        that.storage.get(that.keyContinuation).then((value: string) => {
          if (value) {

            that.alertProvider.doAlert('Esse cadastro é uma continuação de um cadastro anterior. Pode ser que você já esteja cadastrado.', 'Atenção', () => {

              that.tryToRegister(data);

            }, 'Ciente');

          } else {

            that.tryToRegister(data);

          }
        }).catch((error: any) => {

          console.log(error);
          that.tryToRegister(data);

        });

      } else {
        that.alertProvider.doAlert('Houve problemas ao salvar suas informações.', 'Atenção');
      }

    }, (error: any) => {
      console.log(error);
      that.alertProvider.doAlert('Houve problemas ao salvar suas informações.', 'Atenção');
    });
    */
  }

  /**
   * Try to register the data.
   *
   * @param data Data to be registered.
   */
  private tryToRegister(data: NewSubscription) {
    let that = this;
    /*
    let accessData = {
      email: data.email,
      password: data.password
    };

    // Before to try to register, verify if data already exists
    this.doVerification(data).subscribe((emails: any[]) => {
      if (emails.length === 0) {

        // Try to register
        if (!that.networkMonitorProvider.isOnline()) {
          that.alertProvider.doAlert('É necessário estar conectado na Internet para realizar o cadastro.', 'Atenção');
        } else {
          let loader = that.loadingCtrl.create({
            content: 'Cadastrando...',
            //duration: 3000
          });
          loader.present();

          console.log(Config.baseUrl + '/users/registration');
          console.log(data);

          that.http.post(Config.baseUrl + '/users/registration', data)
            .map((res: Response) => res.json())
            .subscribe((response: any) => {
              console.log(response);
              loader.dismiss();

              if (response.emails) {

                that.navCtrl.push(NewRegistrationExistsPage, {
                  emails: response.emails
                }, {
                    animation: 'ios-transition'
                  });

              } else if (response.code) {

                that.alertProvider.doAlert(response.message, 'Atenção');

              } else if (response.created) {

                that.destroyAndLogin(accessData);

              } else {

                that.alertProvider.doAlert('Houve problemas ao cadastrar suas informações.', 'Atenção');

              }
            }, (error: any) => {
              console.log(error);
              loader.dismiss();
              that.alertProvider.doAlert('Houve problemas ao cadastrar suas informações.', 'Atenção');
            });
        }

      } else {

        that.navCtrl.push(NewRegistrationExistsPage, {
          emails: emails
        }, {
            animation: 'ios-transition'
          });

      }
    }, (error: any) => {
      console.log(error)
      this.alertProvider.doAlert('Houve problemas ao verificar suas informações.', 'Atenção');
    })
    */
  }

  private destroyAndLogin(data: any) {
    let that = this;
    that.destroy().subscribe(() => {
      that.registerSuccefull(data);
    }, (error: any) => {
      console.log(error);
      that.registerSuccefull(data);
    });
  }

  private registerSuccefull(data: any) {
    let that = this;
    this.alertProvider.doAlert('Seu cadastro foi realizado com sucesso. Você receberá um e-mail com as informações do seu login. Clique no botão abaixo para pagar sua inscrição.', 'Atenção', () => {
      // TODO: ???
      // that.navCtrl.setRoot(MainPage);
      // that.navCtrl.popToRoot().then(() => {
      //   that.doLogin(data);
      // }).catch((error: any) => {
      //   console.log(error);
      //   that.doLogin(data);
      // });
    });
  }

  /*
  private doLogin(data: any) {
    let loader = this.loadingCtrl.create({
      content: 'Acessando...',
      //duration: 3000
    });
    loader.present();

    let that = this;
    this.authProvider.login(data).subscribe((allowed: any) => {
      if (allowed) {
        that.navCtrl.push(MainPage, {
          loader: loader
        });
      } else {
        loader.dismiss();
        that.alertProvider.doAlert('Acesso negado.', 'Atenção');
      }
    }, (error: any) => {
      console.log(error);
      loader.dismiss();
      that.alertProvider.doAlert('Acesso negado.', 'Atenção');
    });
  }
  */

}



// WEBPACK FOOTER //
// ./src/providers/new-subscription/new-subscription.ts